"use client"

import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import {
  ItemOffersTableReatom,
  ItemOffersTableSkeletonReatom,
} from "./offers-table.reatom"

export function ItemOffersViewReatom() {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={<ItemOffersTableSkeletonReatom />}>
        <ItemOffersTableReatom />
      </Suspense>
    </ErrorBoundary>
  )
}
